import './style.css';

function Footer(){
    const ano = new Date().getFullYear();    
    return <footer className="footer page-footer">
    <div className="container-fluid">
        <div className="row">
            <div className="col-12 text-center">
                <p className="copyright mb-0">
                    {process.env.REACT_APP_VERSION && <>
                        <span className="version">v{process.env.REACT_APP_VERSION}</span>
                        <span className="separator mx-3 d-none d-sm-inline">|</span>
                    </>}
                    <span className="copyright-text">
                        <i className="fa fa-copyright me-1" aria-hidden="true"></i>
                        {ano} <a href='https://www.opnet.com.br' target='_blank' rel="noreferrer">Opnet Informática</a> 
                        <span className="d-none d-md-inline"> - Todos os direitos reservados.</span>
                    </span>
                </p>
            </div>
        </div>
    </div>
</footer>
    
}
export default Footer;